var realPrice = 1
var quantity = 1

function waitForElement(selector) {
    return new Promise(resolve => {
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                console.log(document.querySelector(selector));
                resolve(document.querySelector(selector));
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    })
}

function validateForm(form){
    var inputsRequired = form.querySelectorAll("input:required", "select:required")
    var isValid = true;
    Array.from(inputsRequired).forEach(input => {
        var minLength = Number(input.getAttribute("data-minl"))
        var maxLength = Number(input.getAttribute("data-maxl"))
        if(input.value == null || input.value == "" || input.value.length > maxLength || input.value.length < minLength){
            isValid = false;
            return;
        }
    })
    return isValid;
}

document.addEventListener("DOMContentLoaded", function () {
    realPrice = getSelectedVariantPrice()
    var input = document.getElementsByClassName("quantity__input")[0]
    var form
    var button
    var giftLabel = document.getElementById("gift-label");
    giftLabel.style.opacity = (realPrice >= 100000) ? "1" : "0";
    document.getElementById("plus").addEventListener("click", add);
    document.getElementById("minus").addEventListener("click", less);

    var fieldset = document.getElementsByClassName("product-form__input--pill")[0];
    if(fieldset != null){
        var buttons = fieldset.querySelectorAll('input[type="radio"]');
        Array.from(buttons).forEach(btn => {
            btn.addEventListener("click", function(){
                if(this.checked){
                    var priceTag = document.getElementById(`${this.getAttribute("position")}-price`);
                    realPrice = Number(priceTag.innerHTML) / 100;
                    quantity = 1;
                    var giftLabel = document.getElementById("gift-label");
                    giftLabel.style.opacity = (realPrice >= 100000) ? "1" : "0";
                    onRemove(giftLabel, function(){
                        var giftLabel = document.getElementById("gift-label");
                        giftLabel.style.opacity = (realPrice >= 100000) ? "1" : "0";
                    })
                }
            })
        });
    }

    async function setVars() {
        form = await waitForElement("#_rsi-cod-form-modal-form")
        button = await waitForElement("#_rsi-cod-form-modal-form ._rsi-modal-submit-button")
        if (button != null) {
            console.log("button exists")
            form.addEventListener("submit", function () {
                if(validateForm(form) && realPrice * quantity >= 100000){
                    document.getElementById("gift-overlay").style.display = "flex"
                    console.log("form sent")
                }else{
                    console.log("form invalid")
                }
            })
        }
        onRemove(form, setVars)
    }
    setVars()

    if (input !== null) {
        input.addEventListener("input", function () {
            var w = document.getElementsByTagName("addi-product-widget")[0]
            quantity = input.value
            var price = realPrice * quantity
            var giftLabel = document.getElementById("gift-label");
            giftLabel.style.opacity = (price >= 100000) ? "1" : "0";
            w.setAttribute("price", price)
            onRemove(w, function () {
                var w = document.getElementsByTagName("addi-product-widget")[0]
                console.log(quantity)
                w.setAttribute("price", price)
            })
        })
    }
})

function getSelectedVariantPrice(){
    var fieldset = document.getElementsByClassName("product-form__input--pill")[0];
    var selected = fieldset.querySelector('input[type="radio"]:checked');
    if (selected == null) {
        return Number(document.getElementById("0-price").innerHTML) / 100;
    }
    var priceTag = document.getElementById(`${selected.getAttribute("position")}-price`);
    return Number(priceTag.innerHTML) / 100;
}

function onRemove(element, onDetachCallback) {
    const observer = new MutationObserver(function () {
        if (!document.contains(element)) {
            observer.disconnect();
            onDetachCallback();
        }
    })
    observer.observe(document, {
        childList: true,
        subtree: true
    });
}

function add() {
    if (realPrice == 1) { return }
    var w = document.getElementsByTagName("addi-product-widget")[0]
    quantity += 1
    var price = realPrice * quantity
    var giftLabel = document.getElementById("gift-label");
    giftLabel.style.opacity = (price >= 100000) ? "1" : "0";
    onRemove(w, function () {
        var w = document.getElementsByTagName("addi-product-widget")[0]
        w.setAttribute("price", price)
    })
}

function less() {
    if (realPrice == 1) { return }
    var w = document.getElementsByTagName("addi-product-widget")[0]
    quantity = Math.max(quantity - 1, 1)
    var price = realPrice * quantity
    var giftLabel = document.getElementById("gift-label");
    giftLabel.style.opacity = (price >= 100000) ? "1" : "0";
    onRemove(w, function () {
        var w = document.getElementsByTagName("addi-product-widget")[0]
        w.setAttribute("price", price)
    })
}